import { useEffect, useMemo, useState } from 'react';
import { getGeo, getPublicSettings, getPublicStats, track, captureAdsterraSubidFromUrl, captureFbclidFromUrl } from '../lib/api';
import { injectPixels } from '../lib/pixels';

import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import SocialProofStrip from '../components/SocialProofStrip';
import IsThisYou from '../components/IsThisYou';
import NewEconomy from '../components/NewEconomy';
import BigStats from '../components/BigStats';
import ThreePillars from '../components/ThreePillars';
import Campuses from '../components/Campuses';
import BrokerCta from '../components/BrokerCta';
import CountryVideos from '../components/CountryVideos';
import StudentWins from '../components/StudentWins';
import Testimonials from '../components/Testimonials';
import PathToWealth from '../components/PathToWealth';
import EliteNetwork from '../components/EliteNetwork';
import Pricing from '../components/Pricing';
import OrDoNothing from '../components/OrDoNothing';
import Faq from '../components/Faq';
import FinalCta from '../components/FinalCta';
import Footer from '../components/Footer';
import StickyMobileCta from '../components/StickyMobileCta';
import LatestFromBlog from '../components/LatestFromBlog';

export default function LandingPage() {
  const [settings, setSettings] = useState(null);
  const [geo, setGeo] = useState(null);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    // Capture incoming Adsterra subid (if URL has ?aff_sub=...) so it sticks
    // in localStorage and is forwarded with all subsequent track + broker calls.
    captureAdsterraSubidFromUrl();
    captureFbclidFromUrl();
    (async () => {
      try {
        const [s, g, st] = await Promise.all([getPublicSettings(), getGeo(), getPublicStats()]);
        setSettings(s); setGeo(g); setStats(st);
        injectPixels({
          facebook_pixel_id: s.facebook_pixel_id,
          tiktok_pixel_id: s.tiktok_pixel_id,
          google_ads_id: s.google_ads_id,
          google_analytics_id: s.google_analytics_id,
        });
        const params = new URLSearchParams(window.location.search);
        track({
          type: 'visit',
          country_code: g?.country_code || null,
          country_name: g?.country_name || null,
          utm_source: params.get('utm_source'),
          utm_campaign: params.get('utm_campaign'),
          utm_medium: params.get('utm_medium'),
          referrer: typeof document !== 'undefined' ? document.referrer : null,
        });
      } catch (e) { console.error('load error', e); }
    })();
    const id = setInterval(async () => {
      try { setStats(await getPublicStats()); } catch {}
    }, 45000);
    return () => clearInterval(id);
  }, []);

  const recommendedKey = useMemo(() => {
    const cc = geo?.country_code;
    if (cc === 'BD') return 'bd';
    if (cc === 'IN' || cc === 'PK') return 'inpk';
    return 'other';
  }, [geo]);

  return (
    <main className="min-h-screen bg-[hsl(0_0%_4%)] text-[hsl(0_0%_98%)]">
      <Navbar settings={settings} />
      <Hero settings={settings} geo={geo} recommendedKey={recommendedKey} stats={stats} />
      <StudentWins />
      <EliteNetwork />
      <SocialProofStrip stats={stats} />
      <CountryVideos settings={settings} recommendedKey={recommendedKey} geo={geo} />
      <IsThisYou />
      <NewEconomy />
      <BigStats stats={stats} />
      <ThreePillars />
      <Campuses />
      <BrokerCta settings={settings} geo={geo} />
      <Testimonials />
      <PathToWealth />
      <Pricing settings={settings} geo={geo} />
      <OrDoNothing settings={settings} geo={geo} />
      <Faq />
      <FinalCta settings={settings} geo={geo} />
      <LatestFromBlog />
      <Footer settings={settings} />
      <StickyMobileCta settings={settings} geo={geo} />
    </main>
  );
}
